import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker

const storefrontLessonsPickerModalSelector = createSelector(
	[ getLessonsPicker ],
	lessons_picker => ({
		page: lessons_picker.page,
		search: lessons_picker.search,
		order_field: lessons_picker.order_field,
		order_type: lessons_picker.order_type,
		more: lessons_picker.more,
	})
)

export default storefrontLessonsPickerModalSelector
